var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6205 58.4402C1.60034 58.4199 1.58007 58.3998 1.55991 58.3795C-0.270557 56.549 -0.514893 53.6751 0.959209 51.5471C5.15874 45.4843 10.6595 40.4601 17.1314 36.8043L23.1958 42.8687C19.5399 49.3406 14.5157 54.8414 8.45288 59.0409C6.32487 60.515 3.45085 60.2707 1.6205 58.4402Z",
    fill: "url(#paint0_linear_12_424)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63062 42.0138L17.9862 50.3694C19.9405 48.0502 21.6851 45.5426 23.1955 42.8688L17.1312 36.8044C14.4573 38.3148 11.9498 40.0594 9.63062 42.0138Z",
    fill: "url(#paint1_linear_12_424)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2066 43.587C50.2428 43.587 60 33.8297 60 21.7935C60 9.75727 50.2428 0 38.2066 0C26.1704 0 16.4131 9.75727 16.4131 21.7935C16.4131 33.8297 26.1704 43.587 38.2066 43.587Z",
    fill: "#C32A7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2066 39.3625C47.9096 39.3625 55.7755 31.4966 55.7755 21.7935C55.7755 12.0904 47.9096 4.22449 38.2066 4.22449C28.5035 4.22449 20.6376 12.0904 20.6376 21.7935C20.6376 31.4966 28.5035 39.3625 38.2066 39.3625Z",
    fill: "url(#paint2_linear_12_424)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2065 36.6457C46.4092 36.6457 53.0588 29.9962 53.0588 21.7935C53.0588 13.5909 46.4092 6.94128 38.2065 6.94128C30.0039 6.94128 23.3543 13.5909 23.3543 21.7935C23.3543 29.9962 30.0039 36.6457 38.2065 36.6457Z",
    fill: "url(#paint3_linear_12_424)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0588 21.7935C53.0588 13.5909 46.4092 6.94128 38.2065 6.94128C30.0039 6.94128 23.3543 13.5909 23.3543 21.7935C23.3543 23.57 23.6673 25.2732 24.2393 26.8521H52.1738C52.7458 25.273 53.0588 23.57 53.0588 21.7935Z",
    fill: "url(#paint4_linear_12_424)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7086 11.2915C42.9086 5.49143 33.5046 5.49131 27.7044 11.2915C21.9044 17.0916 21.9044 26.4955 27.7044 32.2957C28.9606 33.5519 30.3861 34.5348 31.9071 35.247L51.6598 15.4943C50.9477 13.9732 49.9648 12.5476 48.7086 11.2915Z",
    fill: "url(#paint5_linear_12_424)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2066 35.0704C45.5392 35.0704 51.4834 29.1261 51.4834 21.7935C51.4834 14.4609 45.5392 8.5166 38.2066 8.5166C30.8739 8.5166 24.9297 14.4609 24.9297 21.7935C24.9297 29.1261 30.8739 35.0704 38.2066 35.0704Z",
    fill: "url(#paint6_linear_12_424)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0147 43.9237L16.0764 37.9853C15.6283 37.5372 15.8656 36.5731 16.6065 35.8321C17.2409 35.1978 18.0573 34.9188 18.5636 35.1635L19.1404 35.4421C21.549 36.6059 23.3942 38.451 24.558 40.8597L24.8366 41.4365C25.0812 41.9428 24.8023 42.7591 24.168 43.3935C23.4269 44.1345 22.4629 44.3719 22.0147 43.9237Z",
    fill: "url(#paint7_linear_12_424)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0147 43.9237C22.4628 44.3719 23.4269 44.1346 24.1679 43.3936C24.8023 42.7592 25.0813 41.9429 24.8366 41.4367L24.5579 40.8599C23.9761 39.6555 23.2239 38.5921 22.316 37.6842L19.0455 40.9547L22.0147 43.9237Z",
    fill: "url(#paint8_linear_12_424)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6065 35.8321C15.8656 36.5731 15.6281 37.5371 16.0764 37.9853L22.0147 43.9237C22.4629 44.3718 23.427 44.1345 24.1679 43.3935C24.5536 43.0079 24.8067 42.5553 24.8919 42.1457L17.8543 35.1082C17.4448 35.1933 16.9922 35.4466 16.6065 35.8321Z",
    fill: "url(#paint9_linear_12_424)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2367 40.6545L19.3458 35.7636C18.9766 35.3944 19.1722 34.6005 19.7824 33.9902C20.3048 33.4678 20.9772 33.2379 21.3942 33.4394L21.8693 33.669C23.8531 34.6274 25.3728 36.1471 26.3313 38.131L26.5609 38.6061C26.7623 39.023 26.5325 39.6954 26.0101 40.2179C25.3998 40.8282 24.6057 41.0236 24.2367 40.6545Z",
    fill: "url(#paint10_linear_12_424)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2365 40.6545C24.6056 41.0237 25.3996 40.8281 26.0099 40.2179C26.5323 39.6955 26.7621 39.023 26.5607 38.6061L26.3311 38.131C25.8518 37.139 25.2323 36.2632 24.4846 35.5155L21.791 38.2091L24.2365 40.6545Z",
    fill: "url(#paint11_linear_12_424)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7822 33.9902C19.1719 34.6005 18.9764 35.3944 19.3455 35.7636L24.2365 40.6545C24.6056 41.0236 25.3996 40.8281 26.0099 40.2179C26.3275 39.9003 26.5361 39.5275 26.6063 39.1901L20.81 33.3939C20.4725 33.4641 20.0998 33.6726 19.7822 33.9902Z",
    fill: "url(#paint12_linear_12_424)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16095 49.8875C1.74939 50.4317 1.34849 50.9849 0.959077 51.5472C0.700913 51.92 0.496538 52.3159 0.34314 52.7248L7.27525 59.6569C7.68412 59.5034 8.08009 59.2991 8.45287 59.041C9.01513 58.6514 9.56837 58.2507 10.1126 57.8391L2.16095 49.8875Z",
    fill: "url(#paint13_linear_12_424)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_424",
    x1: 8.00394,
    y1: 46.2503,
    x2: 11.4065,
    y2: 49.6529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0085F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A5298"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_424",
    x1: 16.1475,
    y1: 43.8525,
    x2: 19.174,
    y2: 40.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_424",
    x1: 50.503,
    y1: 34.09,
    x2: 24.0381,
    y2: 7.62492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C32A7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_424",
    x1: 47.2915,
    y1: 30.8784,
    x2: 30.9028,
    y2: 14.4898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBD5EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12_424",
    x1: 36.5073,
    y1: 16.82,
    x2: 32.9237,
    y2: 6.33437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12_424",
    x1: 30.9126,
    y1: 18.2918,
    x2: 24.2761,
    y2: 15.1063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBD5EF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2853,
    stopColor: "#D9D2EE",
    stopOpacity: 0.285
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4739,
    stopColor: "#D4C9E9",
    stopOpacity: 0.474
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6346,
    stopColor: "#CBBAE2",
    stopOpacity: 0.635
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7795,
    stopColor: "#BFA5D7",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#AF8ACA",
    stopOpacity: 0.913
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A274BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12_424",
    x1: 23.5559,
    y1: 7.14269,
    x2: 42.7415,
    y2: 26.3284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12_424",
    x1: 21.7654,
    y1: 38.1923,
    x2: 19.4015,
    y2: 40.5562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12_424",
    x1: 22.1772,
    y1: 41.8723,
    x2: 22.8906,
    y2: 44.0423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12_424",
    x1: 20.4261,
    y1: 39.5316,
    x2: 18.9471,
    y2: 41.0106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12_424",
    x1: 24.0304,
    y1: 35.9274,
    x2: 22.0834,
    y2: 37.8744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12_424",
    x1: 24.3694,
    y1: 38.9583,
    x2: 24.957,
    y2: 40.7456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12_424",
    x1: 22.9271,
    y1: 37.0305,
    x2: 21.709,
    y2: 38.2486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12_424",
    x1: 0.0937645,
    y1: 38.4369,
    x2: 6.83263,
    y2: 60.5471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1A1A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.9739354d3d8d41f9ab86734d0a210d57.svg";
export { ForwardRef as ReactComponent };